var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CCustomSelect',{attrs:{"placeholder":_vm.$t('i want to'),"options":_vm.options,"model-value":_vm.selectedValue,"header-prefix":_vm.selectedValue ? null : _vm.$t('i want to'),"size":_vm.size},on:{"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }